module.exports = {
    'tables.task.country': 'Country',
    'tables.task.taskNumber': 'task number',
    'tables.task.platform': 'Platform',
    'tables.task.shopName': 'Shop Name',
    'tables.task.perItem': 'per item',
    'tables.task.releaseTime': 'release time',
    'tables.task.creationTime': 'creation time',
    'tables.task.courierNumber': 'tracking number',
    'tables.task.endTime': 'task complete time',
    'tables.task.totalTask': 'total task',
    'tables.task.totalGoods': 'total goods',
    'tables.task.taskStatus': 'task status',
    'tables.task.failReason': 'failure reason',
    'tables.task.failPic': 'failure image',
    'tables.task.orderStatus': 'order status',
    'tables.task.operate': 'operate',
    'tables.task.orderNumber': 'order number',
    'tables.task.payByHand': 'Pay by hand',
    'tables.task.brush': 'brush',
    'tables.task.theActualAmount': 'The actual amount',
    'tables.task.evaluationAccount': 'account',
    'tables.task.taskTimeliness': 'task timeliness',
    'tables.task.courierName':'Courier Name',
    'tables.task.courierPhone':'Courier Phone',
    'tables.task.courierCompany':'Courier Company',

    // 投诉
    'tables.complaint.type': 'Complaint Type',
    'tables.complaint.content': 'Complaints',
    'tables.complaint.screenshot': 'Content screenshot',
    'tables.complaint.time': 'Complaint time',
    'tables.complaint.sum': 'lump sum',
    'tables.complaint.brushGoodsAmount': 'Amount of goods to be brushed',
    'tables.complaint.brushServiceAmount': 'Hand brush commission amount',
    'tables.complaint.result': 'Complaint Outcome',
    'tables.complaint.remark': 'Remark',
    'tables.complaint.status': 'Complaint status',
    'tables.complaint.brush': 'brush hand',

    // acct
    'tables.acct.completeTime': 'Complete time',
    'tables.acct.settlementType': 'Billing type',
    'tables.acct.settlementServicePrice': 'Settlement Commission Amount',
    'tables.acct.commission':'Brush commission amount',
    'tables.acct.settlementGoodsPrice': 'Settlement product amount',

    'tables.acct.settlementStatus': 'billing status',
    'tables.acct.serviceAdminName': 'leader of brush hand',
    'tables.acct.settlementAdminName': 'clearing party',
    'tables.acct.settlementVoucher': 'settlement voucher',
    'tables.acct.settlementTime': 'settlement time',
    'tables.acct.business': 'business',
    'tables.acct.prepaidVoucher': 'prepaid voucher',
    'tables.acct.batchReceive': 'batch receive',

    // brush
    'tables.brush.number': 'brush number',
    'tables.brush.name': 'brush name',
    'tables.brush.mobile': 'brush mobile',
    'tables.brush.account': 'account',
    'tables.brush.state': 'state',
    'tables.brush.commission':'commission',
    'tables.brush.authorizeAllOrder':'authoriz all orders received',


    'navBar.lang': 'Languages',
    'layout.user.link.help': 'Help',
    'layout.user.link.privacy': 'Privacy',
    'layout.user.link.terms': 'Terms',
    'app.copyright.produced': 'Produced by Ant Financial Experience Department',
    'app.preview.down.block': 'Download this page to your local project',
    'app.welcome.link.fetch-blocks': 'Get all block',
    'app.welcome.link.block-list': 'Quickly build standard, pages based on `block` development',
    'alert.user.pwd': 'Tip: the initial password is 123456',
    'alert.Tip': 'Tip',
    'app:edit': 'edit',
    'app:delete': 'delete',
    'app:disable': 'disable',
    'app:enable': 'enable',
    'app:resetPwd': 'reset password',
    'toast:success': 'operation succeeded!',
    'app:download': 'download',
    'app:downloadsphpmb':'Download product review template',
    'app:batchImportshhp':'Batch import of product reviews',
    'app:downloadxd':'Download batch order templates',
    'app:batchImportxd':'Batch Import Order Tasks',
    'app:detail': 'detail',
    'app:printDelivery': 'Print delivery note',

    'app:updatePaidinamount':'Update Paid in Amount',

    'app:please':'Please enter',
    'app:Complaintcontent':'Complaint content',
    'app:update':'Update',

    'app:complaint': 'complaint',
    'app:placeOrder': 'Place order',
    'app:comment': 'Item review',
    'app:signFailed': 'Failed to sign for',
    'app:signSuccess':'Received successfully',
    'app:signStatus': 'Receipt status',
    'app:sign':'sign for',
    'app:ScanCodeSign':'Scan receipt',

    'app:receive': 'receive task',
    'app:assignment': 'assignment',

    'user:title': 'User center',
    'user:changePassword': 'Change password',
    'user:logout': 'Log out',

    'user:logoutMsg': 'Are you sure to log out?',

    'user:companyName': 'Company name',
    'user:expirationTime': 'Expiration time',
    'user:realName': 'Real name',

    'user:changeSuccessMsg': 'The operation is successful. Please log in again',
    'user:oldPassword': 'Old password',
    'user:newPassword': 'New password',

    'user:closeOther': 'Close other',
    'user:closeAll': 'Close all',

    'login:account': 'mobile',
    'login:pwd': 'password',
    'login:login': 'login',
    'login:success': 'login success！',

    'app:count': 'count',

    'conditionExpansion': 'Expansion',
    'conditionCollapse': 'Collapse',

    'messagedetermine':'OK',
    'messagecancel':'Cancel',

    'tableSearchQuery':'Query',
    'tableSearchReset':'Reset',

    'pages.pf.leader.service-list.addBrush': 'add brush',
    'pages.pf.leader.service-list.updateBrush': 'update brush',
    'pages.pf.leader.service-list.deleteMsg': 'Are you sure you want to delete this person?',
    'pages.pf.leader.service-list.resetPassword':
        'Are you sure you want to reset password?The initial password is 123456',
    'pages.pf.leader.service-list.disable': 'Are you sure you want to disable this staff account?',
    'pages.pf.leader.service-list.enable': 'Are you sure you want to enable this staff account?',

    'pages.bs.task.return': 'return',
    'pages.bs.task.returnMsg': 'Are you sure to return and change the task to the demand pool?',

    'pages.ld.task.receive': 'Are you sure to receive this task?',
    'pages.ld.task.receiveMsg':
        'After receiving the task, you need to complete the order within 240 minutes. If it is not completed, it will be automatically returned to the task pool',

    // 下单
    'pages.placeOrder.title': 'Place order',
    'pages.placeOrder.additionalServices': 'Additional services',
    'pages.placeOrder.otherServiceMsg': 'Please upload the task screenshot',

    'pages.upload.extra': 'support. jpg、. PNG format',
    'pages.upload.title': 'upload',
    'pages.placeOrder.transactionScreenshot': 'Transaction screenshot',
    'pages.placeOrder.screenshot': 'Screenshot',
    'pages.placeOrder.failureReason': 'Failure reason',
    'pages.placeOrder.TaskAmount': 'Task amount',
    'pages.placeOrder.PayAmount': 'Pay amount by hand',
    'pages.placeOrder.submit': 'submit',
    'pages.placeOrder.OrderPlacement': 'Order placement',
    'pages.placeOrder.OrderSuccess': 'Order success',
    'pages.placeOrder.Orderfailed': 'Order failed',
    'pages.comment.screenshot': 'Comment screenshot',

    'pages.detail.title': 'Task order details',
    'pages.detail.baseInfo': 'Basic information',

    'pages.detail.cost': 'cost',
    'pages.detail.taskCost': 'Total cost of task',
    'pages.detail.goodsCost': 'Total cost of goods',
    'pages.detail.otherPrice': 'Additional service charge',
    'pages.detail.isFreeShipping': 'Is free shipping',
    'pages.detail.goodsLink': 'Goods link',

    'pages.detail.goodsName': 'Goods name',
    'pages.detail.coupon': 'coupon',
    'pages.detail.goodsCover': 'Goods cover',
    'pages.detail.skuCount': 'Sku count',
    'pages.detail.unitPrice': 'Order unit price',

    'pages.detail.commentStar': 'Comment star',
    'pages.detail.PraiseContent': 'Praise content',
    'pages.detail.ScreenshotOfPraise': 'Screenshot of praise',
    'pages.detail.VideoPraise': 'shopee video praise',

    'pages.detail.inStoreType': 'Way of entering the store',

    'pages.detail.SearchKeywords': 'Search keywords',
    'pages.detail.OtherChannels': 'Other channels',
    'pages.detail.StoreAddress': 'Store address',

    'pages.detail.SortingMethod': 'Sorting method',
    'pages.detail.desc': 'description',

    'pages.detail.required': 'required',

    'pages.detail.notRequired': 'Not required',
    'pages.detail.item1': '1 item',
    'pages.detail.item2': '2 item',
    'pages.detail.item3': '3 item',
    'pages.detail.TaskSituation': 'Task situation',
    'pages.detail.otherServiceScreen': 'Screenshot of additional services',

    'menu.first.task': 'Evaluation',
    'menu.first.task.pool': 'task pool',
    'menu.first.task.Received': 'Received task',
    'menu.first.task.Scan': 'Scan receipt',
    'menu.first.task.detail': 'task detail',
    'menu.first.task.complaint': 'List of complaints',
    'menu.first.task.comment': 'Item review',
    'menu.first.task.placeOrder': 'place order',
  
  
  
    'menu.first.acct': 'money management',
    'menu.first.task.bill': 'commission bill',
  
    'menu.first.service': 'Brush management',
    'menu.first.task.list': 'swipe list',
}  


// WEBPACK FOOTER //
// ./src/components/lang/en.js